import { render, staticRenderFns } from "./BnInput.vue?vue&type=template&id=67b6d724&scoped=true&"
import script from "./BnInput.vue?vue&type=script&lang=js&"
export * from "./BnInput.vue?vue&type=script&lang=js&"
import style0 from "./BnInput.vue?vue&type=style&index=0&id=67b6d724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6d724",
  null
  
)

export default component.exports